import { faqConstants } from '../constants';
import { faqService } from '../../services';

export const faqActions = {
  faqsList,
  addFaq,
  getFaq,
  updateFaq
}

/*
ACTION: Faqs List
*/
function faqsList() {
  return dispatch => {
    dispatch(request());
    return faqService.faqsList()
      .then(
        response => {
          dispatch(success(response.data.body.faqs, 3));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: faqConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: faqConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: faqConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Faq
*/
function addFaq(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return faqService.addFaq(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: faqConstants.ADD_REQUEST } }
  function success(status) { return { type: faqConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: faqConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Faq By ID
*/
function getFaq(faqID) {
  return dispatch => {
    dispatch(request());
    return faqService.getFaq(faqID)
      .then(
        response => {
          console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: faqConstants.GET_REQUEST } }
  function success(item) { return { type: faqConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: faqConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Faq
*/
function updateFaq(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return faqService.updateFaq(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: faqConstants.UPDATE_REQUEST } }
  function success(status) { return { type: faqConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: faqConstants.UPDATE_FAILURE, error } }
}